import { getRandom } from "@tsparticles/engine";
export function generateRandomPolygon(position, sides, radius, rotationAngle = 0) {
    const polygon = [], angle = (Math.PI * 2) / sides;
    for (let i = 0; i < sides; i++) {
        const currentAngle = angle * i + rotationAngle;
        polygon.push({
            x: position.x + radius * Math.cos(currentAngle),
            y: position.y + radius * Math.sin(currentAngle),
        });
    }
    return polygon;
}
export function generateRandomPointWithinPolygon(polygon) {
    const min = { ...polygon[0] }, max = { ...polygon[0] };
    for (const point of polygon) {
        if (point.x < min.x) {
            min.x = point.x;
        }
        if (point.x > max.x) {
            max.x = point.x;
        }
        if (point.y < min.y) {
            min.y = point.y;
        }
        if (point.y > max.y) {
            max.y = point.y;
        }
    }
    let randomPoint = null;
    for (let attempts = 0; attempts < 100; attempts++) {
        const tmpPoint = {
            x: min.x + getRandom() * (max.x - min.x),
            y: min.y + getRandom() * (max.y - min.y),
        };
        if (isPointInPolygon(tmpPoint, polygon)) {
            randomPoint = tmpPoint;
            break;
        }
    }
    return randomPoint;
}
export function generateRandomPointOnPolygonPerimeter(polygon) {
    const sideIndex = Math.floor(getRandom() * polygon.length), startPoint = polygon[sideIndex], endPoint = polygon[(sideIndex + 1) % polygon.length], t = getRandom();
    return { x: startPoint.x + (endPoint.x - startPoint.x) * t, y: startPoint.y + (endPoint.y - startPoint.y) * t };
}
export function isPointInPolygon(point, polygon) {
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const pi = polygon[i], pj = polygon[j];
        const intersect = pi.y > point.y !== pj.y > point.y && point.x < ((pj.x - pi.x) * (point.y - pi.y)) / (pj.y - pi.y) + pi.x;
        if (intersect) {
            inside = !inside;
        }
    }
    return inside;
}
